import { render, staticRenderFns } from "./JenisIklan.vue?vue&type=template&id=ffac6da4"
import script from "./JenisIklan.vue?vue&type=script&lang=js"
export * from "./JenisIklan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports